import { Api } from 'models/services/api';
import { ReadUsersQuery } from 'models/services/graphql';

import { UserCollectionData } from '../collection';

type DataToRead = {
  organizationId: string;
  nextToken?: string;
};

const RequestQuery = `
  query ReadUsers($organizationId: ID!, $nextToken: String) {
    ${ReadUsersQuery}
  }
`;

type ResponseData = {
  data: {
    readUsers: UserCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: UserCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readUsers;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
